import { AppTheme } from "@/theme";
import { useMediaQuery, useTheme } from "@mui/material";

export function useIsTablet() {
  const theme: AppTheme = useTheme();
  return useMediaQuery(theme.breakpoints.down("md"));
}
